module.exports = "/images/veil-9.jpg";